<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[80vh] overflow-hidden flex flex-col border border-gray-200 shadow-lg m-4">
      <div class="flex justify-between items-center mb-4 flex-shrink-0">
        <h3 class="text-xl font-semibold">{{ typeName }}</h3>
        <button class="text-textSub text-xl cursor-pointer" @click="$emit('close')">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="flex-1 overflow-y-auto space-y-6">
        <div v-for="(work, index) in works" :key="index" class="border-b border-gray-200 pb-4">
          <div class="flex justify-between items-center mb-2">
            <h4 class="font-medium">{{ work.name }}</h4>
            <span class="text-sm text-textSub">{{ work.time }}</span>
          </div>
          <p class="text-textSub whitespace-pre-line">{{ truncateText(work.intro, 100) }}</p>
          <div class="mt-2 flex flex-wrap items-center gap-3">
            <button type="button" class="copy-btn" @click="copyOne(work)">
              <i class="fa-solid fa-copy mr-1"></i>复制本文
            </button>
            <button type="button" class="text-sm text-primary border border-primary rounded-md px-3 py-1.5 btn-hover" @click="openFull(work)">
              <i class="fa-solid fa-file-lines mr-1"></i>查看全文
            </button>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 flex-shrink-0 -mx-6 -mb-6 mt-4 rounded-b-lg">
        <div class="text-sm text-textSub">第 {{ currentPage }} 页</div>
        <div class="space-x-2">
          <button
            class="px-3 py-1 rounded border text-sm btn-hover"
            :class="currentPage <= 1 ? 'border-gray-200 text-gray-300 cursor-not-allowed' : 'border-gray-300 text-textMain'"
            :disabled="currentPage <= 1"
            @click="$emit('prev-page')"
          >上一页</button>
          <button
            class="px-3 py-1 rounded border text-sm btn-hover"
            :class="!hasMore ? 'border-gray-200 text-gray-300 cursor-not-allowed' : 'border-gray-300 text-textMain'"
            :disabled="!hasMore"
            @click="$emit('next-page')"
          >下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewAllModal',
  props: {
    typeName: { type: String, default: '' },
    works: { type: Array, default: () => [] },
    currentPage: { type: Number, default: 1 },
    hasMore: { type: Boolean, default: false }
  },
  methods: {
    truncateText (text, maxLen) {
      if (text === null || text === undefined) return ''
      const str = String(text)
      const len = typeof maxLen === 'number' ? maxLen : 100
      if (len <= 0) return ''
      return str.length > len ? str.slice(0, len) + '…' : str
    },
    copyOne (work) {
      const text = `标题：${work.name}\n\n内容：${work.intro}`
      this.$emit('copy', text)
    },
    pickWorkBody (work) {
      if (!work || typeof work !== 'object') return ''
      if (work.content != null) return String(work.content)
      if (work.text != null) return String(work.text)
      if (work.intro != null) return String(work.intro)
      if (work.body != null) return String(work.body)
      return ''
    },
    openFull (work) {
      const title = work && work.name != null ? String(work.name) : '作品'
      const time = work && (work.time != null ? String(work.time) : (work.date != null ? String(work.date) : ''))
      const body = this.pickWorkBody(work)
      this.$emit('open-full', { title: title, time: time, body: body })
    }
  }
}
</script>
